export default {
  fillFlow({ commit }, flow) {
    let formattedFlow = {}
    formattedFlow.title = flow.description
    formattedFlow.integrator= flow.connector.uuid
    formattedFlow.icon= flow.icon
    formattedFlow.saleFlow= flow.names
    formattedFlow.roles = flow.roles.map(r => r.uuid)
    formattedFlow.initialStatus = flow.initial_sale_status.id
    formattedFlow.personType = flow.person_types
    formattedFlow.hasScheduling = flow.has_installation_schedule

    commit("updateFlow", formattedFlow)
    commit("updateIsSelectAllRoles", flow.all_role)
  },
}